import React from 'react';
import { Link } from 'react-router-dom';
import PaymentForm from '../../components/PaymentForm/PaymentForm';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      {/* Return Home Button top-left */}
      <Link to="/" className="return-home-button">Return Home</Link>

      {/* Hero */}
      <section className="services-hero">
        <div className="container">
          <h1>Services</h1>
          <p>Secure Payment Portal</p>
        </div>
      </section>

      <section className="services-body">
        <div className="container">
          <PaymentForm />
        </div>
      </section>
    </div>
  );
};

export default Services;

